import { useState } from "react";
import mergeCssClasses from "utils/mergeCssClasses";

import UserInfo from "./components/UserInfo";
import ChangePassword from "./components/ChangePassword";
import { CrossSvg } from "svg/icons";
import "./profile-settings.scss";

export default function ProfileSettings({ show, onClose }: { 
   show: boolean;
   onClose: () => void;
}) {

   const [ show_form, setShowForm ] = useState( false );

   return (
      <> 
         { show && <div className="overlay"/> }
         
         <div className={ mergeCssClasses( "profile-settings", show && "show" )}>

            <div className="profile-settings-head"> 
               <h2> Ustawienia profilu </h2>
               <CrossSvg 
                  cursor="pointer"
                  onClick={() => {
                     onClose();
                     setShowForm( false ); 
                  }}   
               />
            </div>

            <div className="divider"></div>

            <UserInfo/>

            <div className="divider"></div>

            <ChangePassword
               show_form={ show_form }
               setShowForm={ setShowForm }
            />
         </div>
      </>
   )
}